
import DSKFullForm from "../components/dsk/DSKFullForm";

export default function DSKFormPage() {
  return <DSKFullForm />;
}